var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetchProductData } from "./Fetch";
import * as parse from "./Parse";
import { DTOTransformer } from "./Parse/Transformer/DTOTransformer";
import { plannerExists } from "./Planners";
const useDexf = (appId, segment) => {
    const _getProducts = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!plannerExists(appId))
            throw new Error("The app id was not found as a sub planner in the Planners.ts file.");
        const productData = yield fetchProductData(appId, segment);
        const transformer = DTOTransformer();
        return transformer.transform(productData);
    });
    return {
        getProducts: _getProducts,
    };
};
export { useDexf, parse };
